import { getSupabase } from '../services/supabase';

export const requestPresentationLibrary = async (signal: AbortSignal) => {
  const result = await getSupabase()
    .from('presentations_ui_v1' as 'presentation')
    .select(
      'presentation_id,title,description,status,updated_at,latest_version_id,latest_version_no,latest_version_status,lesson_count,can_manage,author_account_id',
    )
    .order('updated_at', { ascending: false })
    .limit(100)
    .abortSignal(signal);
  if (result.error) throw result.error;
  return result.data;
};
